import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { $apiWithoutClient } from 'modules/global';

import { IOlympicCourse } from '..';

export const useOlympicCourse = (id?: string) => {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...args } = useQuery<{ olympicCourse: IOlympicCourse[] }>({
    queryKey: ['olympic-course'],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get('/olympic/olympic-courses', { params: { olympic_id: id } });

      return { olympicCourse: data };
    },
    enabled: isAuthenticated,
  });

  return { ...data, ...args };
};
